module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-text"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter01"
    }
  }, [_vm._v("Foreword by Barbara Kafka")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter02"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter03"
    }
  }, [_vm._v("Editor’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch01_01"
    }
  }, [_vm._v("The Stomach, Heart, and Spirit of the House")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch01_02"
    }
  }, [_vm._v("Tools of My Trade")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch01_03"
    }
  }, [_vm._v("To Grind or Not to Grind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_01"
    }
  }, [_vm._v("Whatever Happened to Breakfast?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_02"
    }
  }, [_vm._v("Hearty Luncheon Dishes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_03"
    }
  }, [_vm._v("In Search of Cassoulet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_04"
    }
  }, [_vm._v("Tea and Crumpets")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_05"
    }
  }, [_vm._v("Dishes to Fight Over")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_06"
    }
  }, [_vm._v("Summer Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_07"
    }
  }, [_vm._v("Outdoor Chefmanship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_08"
    }
  }, [_vm._v("The Art of Picnicking")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch02_09"
    }
  }, [_vm._v("Christmas in Provence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Stock Is a Broth Is a Bouillon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What Is a Salad?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Watercress: More Than a Garnish")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All-American Cheese")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Delectable Oyster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pleasures of Lobster")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Invented the Hamburger?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corn It Yourself")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wondrous Artichoke")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belgian Endive: The Elegant Vegetable")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tabitha Tickletooth’s Way with Potatoes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baked Potatoes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hominy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chess Pie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Pie")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream and Schlag")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quince, a Forgotten Fruit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhubarb, American “Pie Plant”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marmalade, Bittersweet Treat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praline Puzzle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk About Bread")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pickling Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Taste for Sauerkraut")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Even Vinegar Has a Mother")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Love Mustard")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch03_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Garlic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch04_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vogue for Vodka")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch04_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch04_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rare White Brandies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch04_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Champagne: Bottled Gaiety")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch04_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mint Julep")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch04_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Year Remedies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch05_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hotel Dining in the Grand Manner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch05_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eating and Drinking in Ireland")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch05_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Falling and Rising Stars of Gastronomy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch05_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eating My Way Across the Atlantic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch05_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Meals on Wheels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch05_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Send It Back")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Am on a Diet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dieters’ Secret")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hold the Vinaigrette")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Friendly Egg")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch06_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hospital Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Salute to Women")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chinese Cuisine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indian Cooking")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swiss Culinary Contrasts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Food of Provence")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Praise of English Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch07_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“American” Cooking")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch08_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An American Attitude Toward Food")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch08_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Berrying")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch08_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life at Its Best")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Recipes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d7b0912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 69
// module chunks = 0